import e from'./../../ext-esm/style-inject/dist/style-inject.es.js';var o={root:"Header_root__c1ZfD"};e(".Header_root__c1ZfD{margin:0}");export{o as default};
